import { render, staticRenderFns } from "./caigou.vue?vue&type=template&id=b357c9e0&scoped=true&"
import script from "./caigou.vue?vue&type=script&lang=js&"
export * from "./caigou.vue?vue&type=script&lang=js&"
import style0 from "./caigou.vue?vue&type=style&index=0&id=b357c9e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b357c9e0",
  null
  
)

export default component.exports